import { render, staticRenderFns } from "./servico.vue?vue&type=template&id=3ae9f073&"
import script from "./servico.vue?vue&type=script&lang=js&"
export * from "./servico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports